// TODO: this probably should be coming from scratch-l10n
// Tracking in https://github.com/LLK/scratch-l10n/issues/32
export default ['he'];
